import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import Form from '../../components/Forms/Form/Form';
import { NavigateTo, Utils } from '../../Utils.js';
import { withAppContext } from '../../contexts/AppContext';
import './AccountCreate.css'; 
import { th } from 'framer-motion/client';
import PageHeader from '../../components/PageHeader/PageHeader.js';

import './AccountCreate.less';

class AccountCreate extends React.Component {
    
    state = {
      redirect: false,
    };

    constructor(props) {
      super(props);
      
      this.appRef = this.props.appContext.appRef;
      this.formRef = React.createRef();
    }

    hiddens = {
      count_address_P: 1,
      count_address_B: 1,
      id_B_1:'',
      id_P_1:'',
      delete_address_B:'',
      delete_address_P:'',
      new_address_B:'',
      new_address_P:''
    };

  /**
   * Form hívja meg ha változás történt egy mezőben
   */
  on_form_change(key, value) {
    if (['reg_type_int','is_company_blob_B_1'].includes(key)) // itt add meg azokat a mezőket, amikre reagálni kell
    {
       if(this.formRef.current) {
          this.formRef.current.load_form_data(true);
       }
    }
  }

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    this.appRef.current.handleLoginSuccess(params.result); // beállítjuk a bejelntkezés utáni állapotot
    this.setState({redirect: true});
  }

  render() { 

    if (this.state.redirect===true){return <NavigateTo toURL='/'></NavigateTo>}

    return <div className={`container floating_container page_account_create`}>
      <div className='floating_container_header no_drop_shadow no_border'>
        <PageHeader isHistoryBack={true} no_close={true} title={i18n.t('accountCreateTitle')}></PageHeader>
      </div>
      <div className="floating_container_content">
       
        <div className="form_wrapper"> 


            <Form onSuccess={(params) => {this.on_submit_success(params)}} ref={this.formRef} hiddens={this.hiddens} name="account_create" submit_text={i18n.t('accountCreateSubmit')} parent={this} />

            <div className='sign_in_link'>
              <Link data-type="in_app" className="sign_in" to="/sign-in">{i18n.t('accountCreateLogin')}</Link>
            </div>
            

          </div>
      </div>
    </div>;
  }

}

export default withAppContext(AccountCreate);